import _isNil from 'lodash/isNil';

export function getItemModifierSets(allModifierSets, itemModifierSetIds) {
  const [modifiersWithIds, modifiersWithLocalIds, newModifierSets] = allModifierSets.reduce(
    (acc, modifierSet, index) => {
      const [accModifiersWithIds, accModifiersWithLocalIds, accNewModifierSets] = acc;
      const { id, localId } = modifierSet;
      if (itemModifierSetIds.includes(id)) {
        accModifiersWithIds.push({ ...modifierSet, index });
      } else if (itemModifierSetIds.includes(localId)) {
        accModifiersWithLocalIds.push({ ...modifierSet, index });
      } else if (_isNil(id) && !_isNil(localId)) {
        accNewModifierSets.push({ ...modifierSet, index });
      }
      return acc;
    },
    [[], [], []],
  );

  const finalModifiers = [...modifiersWithIds, ...modifiersWithLocalIds, ...newModifierSets].filter(
    Boolean,
  );

  finalModifiers.sort((modifier1, modifier2) => {
    const modifier1Id = modifier1.id || modifier1.localId;
    const modifier2Id = modifier2.id || modifier2.localId;

    const modifier1Index = itemModifierSetIds.indexOf(modifier1Id);
    const modifier2Index = itemModifierSetIds.indexOf(modifier2Id);

    if (modifier1Index === -1) return 1;
    if (modifier2Index === -1) return -1;
    return modifier1Index - modifier2Index;
  });

  return finalModifiers;
}
